import React from 'react'
import styled from 'styled-components'
import {
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Row,
  Col,
  Button,
} from 'reactstrap'
import get from 'lodash/get'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export const Leave = (props) => {
  const data = get(props, 'data', [])

  return (
    <Modal
      isOpen={ get(props, 'showDetail') }
      toggle={ get(props, 'handleDetail') }
    >
      <ModalHeader toggle={ get(props, 'handleDetail') }>
        <Header>
          Leave Request
        </Header>
      </ModalHeader>
      <ModalBody style={ { overflowY: 'auto', height: '500px' } }>
        <LabelTextInfo>Employee Name</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data[0], 'name', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Leave Type</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data[0], 'leave_type', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Leave Date</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data[0], 'start_date', '') } - { get(data[0], 'end_date', '') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Leave Time</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data[0], 'leave_time', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Total Leave Day</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data[0], 'days', 0) } days</TextInfo>
          </Col>
        </Row >
        <LabelTextInfo>Submit Date</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data[0], 'created', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Approver</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data[0], 'approver', '-') }</TextInfo>
          </Col>
        </Row>
        { get(data[0], 'attachment_url', '') !== '' &&
          <div>
            <LabelTextInfo>Attachments</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>
                  <CustomButton
                    color="info"
                    onClick={ () => window.open(get(data[0], 'attachment_url', ''), 'blank') }
                  >Download</CustomButton>
                </TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'status', '') !== '' &&
          <div>
            <LabelTextInfo>Status</LabelTextInfo>
            <Row>
              <Col>
                <span style={ { color: statusColor(get(data[0], 'status', '')), fontWeight: 'bold' } }>
                  <TextInfo>{ get(data[0], 'status', '-') }</TextInfo>
                </span>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_request_user', '') !== '' &&
          <div>
            <LabelTextInfo>Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_request_user', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_approver', '') !== '' &&
          <div>
            <LabelTextInfo>Approver Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_approver', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_hr', '') !== '' &&
          <div>
            <LabelTextInfo>HR Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_hr', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data[0], 'remark_cancel', '') !== '' &&
          <div>
            <LabelTextInfo>Cancel Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data[0], 'remark_cancel', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { data.length > 1 &&
        <div>
          <DropdownItem divider />
          <LabelTextInfo>Employee Name</LabelTextInfo>
          <Row>
            <Col>
              <TextInfo>{ get(data[1], 'name', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Leave Type</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'leave_type', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Leave Date</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'start_date', '') } - { get(data[1], 'end_date', '') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Leave Time</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'leave_time', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Total Leave Day</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'days', 0) } days</TextInfo>
            </Col>
          </Row >
          <LabelTextInfo>Submit Date</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'created', '-') }</TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Approver</LabelTextInfo>
          <Row >
            <Col>
              <TextInfo>{ get(data[1], 'approver', '-') }</TextInfo>
            </Col>
          </Row>
          { get(data[1], 'attachment_url', '') !== '' &&
            <div>
              <LabelTextInfo>Attachments</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>
                    <CustomButton
                      color="info"
                      onClick={ () => window.open(get(data[1], 'attachment_url', ''), 'blank') }
                    >Download</CustomButton>
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'status', '') !== '' &&
            <div>
              <LabelTextInfo>Status</LabelTextInfo>
              <Row>
                <Col>
                  <span style={ { color: statusColor(get(data[1], 'status', '')), fontWeight: 'bold' } }>
                    <TextInfo>{ get(data[1], 'status', '-') }</TextInfo>
                  </span>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_request_user', '') !== '' &&
            <div>
              <LabelTextInfo>Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_request_user', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_approver', '') !== '' &&
            <div>
              <LabelTextInfo>Approver Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_approver', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_hr', '') !== '' &&
            <div>
              <LabelTextInfo>HR Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_hr', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(data[1], 'remark_cancel', '') !== '' &&
            <div>
              <LabelTextInfo>Cancel Remarks</LabelTextInfo>
              <Row>
                <Col>
                  <TextInfo>{ get(data[1], 'remark_cancel', '-') }</TextInfo>
                </Col>
              </Row>
            </div>
          }
        </div>
        }
      </ModalBody>
    </Modal>
  )
}

const LabelTextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 0px;
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/show-leave.js